import { render, staticRenderFns } from "./PrioritySelect.vue?vue&type=template&id=13f7527c&"
import script from "./PrioritySelect.vue?vue&type=script&lang=js&"
export * from "./PrioritySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports